import { type IntlShape } from 'react-intl';

import getUserRecommendations from '@atlaskit/smart-user-picker/recommendation-client';

import type { ProductKeyType } from '../types.ts';

type GetOwnersProps = {
	query: string;
	userId: string;
	cloudId: string;
	productKey: ProductKeyType;
	maxNumberOfResults: number;
	intl: IntlShape;
};

export const getOwners: ({
	query,
	userId,
	cloudId,
	productKey,
	maxNumberOfResults,
	intl,
}: GetOwnersProps) => Promise<import('@atlaskit/user-picker').OptionData[]> = ({
	query,
	userId,
	cloudId,
	productKey,
	maxNumberOfResults,
	intl,
}: GetOwnersProps) => {
	const requestParams = {
		context: {
			contextType: 'owners',
			principalId: userId,
			productAttributes: {
				isEntitledConfluenceExternalCollaborator: true,
			},
			productKey,
			siteId: cloudId,
		},
		includeGroups: false,
		includeTeams: false,
		includeUsers: true,
		maxNumberOfResults,
		performSearchQueryOnly: false,
		query,
	};

	return getUserRecommendations(requestParams, intl);
};
